import { action }         from 'mobx';
import { makeObservable } from 'mobx';
import { observable }     from 'mobx';

export const ONBOARDING_TARGET_CLASS = 'onboarding-target';

export type OnboardingTarget = 'draw' | 'name' | 'color' | 'preview' | 'delete' | 'undo';

export class OnboardingStore {
	@observable target: OnboardingTarget | null = null;
	@observable previewOpenings = 0;
	@observable drawMenuOpen = false;

	constructor() {
		makeObservable(this);
	}

	@action point(target: OnboardingTarget | null) {
		this.target = target;
	}

	@action setDrawMenuOpen(open: boolean) {
		this.drawMenuOpen = open;
	}

	@action notePreview() {
		this.previewOpenings++;
	}

	targetClass(target: OnboardingTarget) {
		return this.target === target ? ONBOARDING_TARGET_CLASS : undefined;
	}
}

export default new OnboardingStore();
